var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('message-alert'),_vm._v(" "),_c('navbar',{staticClass:"flat",scopedSlots:_vm._u([{key:"extension",fn:function(){return [_c('business-tabs')]},proxy:true}])}),_vm._v(" "),_c('v-main',[_c('nuxt')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }